import React from 'react'
import { Link } from 'react-router-dom'

type GutstringBrandProps = {
  /** `light` = white on dark backgrounds; `dark` = black on white backgrounds */
  variant?: 'light' | 'dark'
  className?: string
  linkToHome?: boolean
}

const WAVE_SVG = (
  <svg
    width="28"
    height="16"
    viewBox="0 0 36 20"
    fill="none"
    aria-hidden="true"
    className="shrink-0 opacity-85"
  >
    <path
      d="M2 12 Q8 4 14 12 Q20 20 26 12 Q32 4 34 10"
      stroke="currentColor"
      strokeWidth="2"
      fill="none"
      strokeLinecap="round"
    />
  </svg>
)

export function GutstringBrand({
  variant = 'dark',
  className = '',
  linkToHome = false,
}: GutstringBrandProps) {
  const colorClass = variant === 'light' ? 'text-white' : 'text-black'
  const baseClass = `inline-flex items-center gap-2.5 font-mono font-medium uppercase tracking-[0.2em] text-[0.6875rem] md:text-[0.825rem] ${colorClass}`

  const content = (
    <>
      {WAVE_SVG}
      <span>GUTSTRING</span>
    </>
  )

  if (linkToHome) {
    return (
      <Link
        to="/"
        className={`${baseClass} no-underline hover:opacity-90 transition-opacity ${className}`}
      >
        {content}
      </Link>
    )
  }

  return <span className={`${baseClass} ${className}`}>{content}</span>
}
